import { ValidatorFn } from '@angular/forms';
import { ExtendedFormControl } from '../extended-form-control.class';

export class TextareaControl extends ExtendedFormControl {
    readonly inputType = 'textarea';

    constructor(name: string, value: string = '', validations: ValidatorFn[] = [], disabled = false) {
        super(name, value, validations, disabled);
    }
}
